import React, { useContext, useEffect, useRef, useState } from 'react';
import MenuHeader from './../MenuHeader';
import { ProductContext } from '../../../../store';
import { PostData } from '../../../../services/FetchData';
import DraggableItem from './DraggableItem';
import { toast } from 'react-toastify';
import ProductSkeleton from '../../../Skeleton/ProductSkeleton';

const Products = ({type}) => {
	const [isLoading, setIsLoading]	= useState(false),
		[searchProductPhrase, setSearchProductPhrase]	= useState(""),
		[debouncedProductSearch, setDebouncedProductSearch]	= useState(""),
		[disableFlag, setDisableFlag]	= useState(true),
		divRef	= useRef(null),
		timerRef	= useRef(null),
		[hoverProductId, setHoverProductId] = useState(null),
		[height, setHeight] = useState("100vh"),
		[actionLoader, setActionLoader] = useState(false),
		[buriedNotAttached, setBuriedNotAttached] = useState([]),
		{
			products,
			searchPhrase,
			categoryId,
			newProducts,
			setNewProducts,
			addedProductIds,
			setAddedProductIds,
			addedProducts,
			setAddedProducts,
			currentWebsiteId,
			setProducts,
			productCount,
			shopCurrency,
			hasMore,
			productOrder,
			promoted,
			setPromoted,
			buried,
			setBuried,
			buriedProducts,
			setBuriedProducts,
			hiddenProducts,
			hidden,
			setHidden,
			setHiddenProducts,
			pinnedItems,
			setPinnedItems,
			setPinnedProductIndex,
			pinnedProductIndex,
			originalProducts,
			setOriginalProducts,
			hiddenProductIndex,
			setHiddenProductIndex,
			originalProductOrder,
			selectedPromoTiles,
			setSelectedPromoTiles,
			dynamicItems,
			setDynamicItems,
			newProductOrder,
			setNewProductOrder
		}	= useContext(ProductContext)

	useEffect(() => {
		if( currentWebsiteId ){
			setSearchProductPhrase("")
			setDebouncedProductSearch("")
			setNewProducts([])
		}
	}, [currentWebsiteId])

	useEffect(() => {
		if( products.length > 0 ){
			setDisableFlag(false)
		}else{
			setDisableFlag(true)
		}
	}, [products])

	useEffect(() => {
		if (!hasMore && buriedNotAttached.length > 0) {
			let buriedNotAttachedLocal = [...buriedNotAttached],
				productsLocal = [...products]
			for (let i = 0; i < buriedNotAttachedLocal.length; i++) {
				let currentBuriedNotAttached = buriedNotAttachedLocal[i]
				productsLocal.push(currentBuriedNotAttached)
			}
			setProducts(productsLocal)
			setBuriedNotAttached([])
		}
	}, [hasMore, buriedNotAttached])

	useEffect(() => {
		if (searchProductPhrase) {
			timerRef.current = setTimeout(() => {
				setDebouncedProductSearch(searchProductPhrase);
			}, 2000); // 500ms delay
		}else{
			setDebouncedProductSearch("")
			setNewProducts([])
		}
		return () => {
			if (timerRef.current) {
				clearTimeout(timerRef.current); // Cleanup on unmount or query change
			}
		}
	}, [searchProductPhrase])

	useEffect(() => {
		if( debouncedProductSearch ){
			getOutOfContextProduct()
		}
	}, [debouncedProductSearch])
	
	useEffect(() => {
		const calculateHeight = () => {
			if (divRef.current) {
				const topPosition = divRef.current.getBoundingClientRect().top
				const newHeight = `calc(100vh - ${topPosition}px)`
				setHeight(newHeight)
			}
		}
		// Calculate height initially
		calculateHeight()

		// Recalculate height on window resize
		window.addEventListener("resize", calculateHeight)
		return () => {
			window.removeEventListener("resize", calculateHeight)
		}
	}, [divRef])

	const getOutOfContextProduct = () => {
		setIsLoading(true)
		let data = {searchPhrase: debouncedProductSearch, addedProductIds, type, q: searchPhrase, collectionId: categoryId, websiteId: currentWebsiteId},
			url	= "api/v1/shopify/getOutOfContentProduct"
		PostData("ms3", url, data).then(response => {
			if( response !== "Invalid" && response !== undefined ){
				if( response.status === "success" ){
					setNewProducts(response.data.products)
				}else if( response.status === "failure" ){
					toast.error(response.message)
				}else{
					toast.error(response.message.message)
				}
			}
			setIsLoading(false)
		})
	}

	const getPriceRange = (product) => {
		let min = product.price,
			max = product.price;
		if (typeof product.variants !== "undefined" && product.variants.length > 0) {
			min = product.variants[0].calculated_price > 0 ? product.variants[0].calculated_price : (product.variants[0].sale_price > 0 ? product.variants[0].sale_price : product.variants[0].price)
			max = min
			for (let i = 0; i < product.variants.length; i++) {
				let currentVariant = product.variants[i]
				if (currentVariant.calculated_price > 0) {
					if (min > currentVariant.calculated_price) {
						min = currentVariant.calculated_price
					} else if (max < currentVariant.calculated_price) {
						max = currentVariant.calculated_price
					}
				} else if (currentVariant.sale_price > 0) {
					if (min > currentVariant.sale_price) {
						min = currentVariant.sale_price
					} else if (max < currentVariant.sale_price) {
						max = currentVariant.sale_price
					}
				} else if (currentVariant.price > 0) {
					if (min > currentVariant.price) {
						min = currentVariant.price
					} else if (max < currentVariant.price) {
						max = currentVariant.price
					}
				}
			}
		}
		return { min, max }
	}

	const formPriceText = (price) => {
		let priceAmt = new Intl.NumberFormat('en-US', {
			style: 'currency',
			currency: shopCurrency,
		}).format(price);
		return priceAmt
	}

	const formatPrice = (product) => {
		let { min, max } = getPriceRange(product)
		if (min === max) {
			if (product.sale_price > 0) {
				return <><span className="cbPriceList">{formPriceText(product.sale_price)}</span><span className="cbPriceList cbOriginalPrice">{formPriceText(product.price)}</span></>
			} else {
				return <span className="cbPriceList">{formPriceText(product.price)}</span>
			}
		} else {
			let minPrice = formPriceText(min),
				maxPrice = formPriceText(max);
			return <span className="cbPriceList">{minPrice} - {maxPrice}</span>
		}
	}

	const productMouseOver = (producId) => {
		if (hoverProductId !== producId) {
			setHoverProductId(producId)
		}
	}

	const promptProduct = (productId) => {
		setActionLoader(true)
		let promotedLocal = [...promoted],
			pinnedItemsLocal = { ...pinnedItems },
			buriedLocal = [...buried],
			dynamicItemsLocal = {...dynamicItems},
			buriedProductsLocal = [...buriedProducts],
			addedProductsLocal	= {...addedProducts},
			addedProductIdsLocal	= [...addedProductIds],
			productIndex = newProductOrder.get(productId) ?? -1,
			productsLocal = [...products],
			newProductsLocal	= [...newProducts],
			selectedPromoTilesLocal	= {...selectedPromoTiles},
			pinnedWIthPromoted = {...pinnedItemsLocal, ...selectedPromoTilesLocal},
			element = productIndex >= 0 ? newProductsLocal.splice(productIndex, 1)[0] : {},
			promotedPinned	= {},
			buriedPinned	= {},
			onlyPinnedItemsLocal =  {},
			pinnedPositions = [],
			pPPPosition = typeof pinnedItemsLocal[productId] !== "undefined" ? pinnedItemsLocal[productId] : null,
			promotedPosition = 0;		
		Object.keys(pinnedWIthPromoted).forEach((item) => {
			if( promotedLocal.indexOf(item) !== -1 ){
				promotedPinned[item] = pinnedWIthPromoted[item]
			}else if( buriedLocal.indexOf(item) !== -1 ){
				buriedPinned[item] = pinnedWIthPromoted[item]
			}else{
				onlyPinnedItemsLocal[item] = pinnedWIthPromoted[item]
			}
		})
		pinnedPositions = Object.values(onlyPinnedItemsLocal).sort((a, b) => Number(a) - Number(b))
		if(productIndex === -1){
			return
		}
		while( pinnedPositions.indexOf(promotedPosition) !== -1 ){
			promotedPosition = promotedPosition + 1
		}
		if( typeof onlyPinnedItemsLocal[productId] !== "undefined" ){
			delete onlyPinnedItemsLocal[productId]
			delete pinnedItemsLocal[productId]
			pinnedPositions = Object.values(onlyPinnedItemsLocal).sort((a, b) => Number(a) - Number(b))
		}
		if (buriedLocal.indexOf(productId) !== -1) {
			let buriedIndex = buriedLocal.indexOf(productId)
			buriedLocal.splice(buriedIndex, 1)
			buriedProductsLocal.splice(buriedIndex, 1)
			let sortedKeyArray = Object.entries(buriedPinned).sort((a, b) => Number(a[1]) - Number(b[1])).map(([key]) => key)
			let currentBuriedPosition = sortedKeyArray.indexOf(productId)
			for( let i = 0; i < currentBuriedPosition; i++ ){
				if( typeof pinnedItemsLocal[sortedKeyArray[i]] !== "undefined" ){
					let newChangePosition = pinnedItemsLocal[sortedKeyArray[i]] + 1
					while( pinnedPositions.indexOf(newChangePosition) !== -1 ){
						newChangePosition = newChangePosition + 1
					}
					pinnedItemsLocal[sortedKeyArray[i]] = newChangePosition
				}
			}
			delete buriedPinned[productId]
		}
		if (promotedLocal.indexOf(productId) === -1) {
			for( let i = 0; i < promotedLocal.length; i++ ){
				if( typeof pinnedItemsLocal[promotedLocal[i]] !== "undefined" ){
					let newChangePosition = pinnedItemsLocal[promotedLocal[i]] + 1
					while( pinnedPositions.indexOf(newChangePosition) !== -1 ){
						newChangePosition = newChangePosition + 1
					}
					pinnedItemsLocal[promotedLocal[i]] = newChangePosition
				}
			}
			promotedLocal.push(productId)
		}else if( promotedLocal.indexOf(productId) !== -1 ){
			let sortedKeyArray = Object.entries(promotedPinned).sort((a, b) => Number(a[1]) - Number(b[1])).map(([key]) => key)
			let currentPromotedPosition = sortedKeyArray.indexOf(productId)
			for( let i = 0; i < currentPromotedPosition; i++ ){
				if( typeof pinnedItemsLocal[sortedKeyArray[i]] !== "undefined" ){
					let newChangePosition = pinnedItemsLocal[sortedKeyArray[i]] + 1
					while( pinnedPositions.indexOf(newChangePosition) !== -1 ){
						newChangePosition = newChangePosition + 1
					}
					pinnedItemsLocal[sortedKeyArray[i]] = newChangePosition
				}
			}
		}
		addedProductIdsLocal.push(productId)
		addedProductsLocal[productId]	= promotedPosition
		productsLocal.splice(promotedPosition, 0, element)
		pinnedItemsLocal[productId] = promotedPosition
		if (typeof pinnedProductIndex[productId] === "undefined") {
			let pinnedProductIndexLocal = { ...pinnedProductIndex }
			pinnedProductIndexLocal[productId] = originalProductOrder.get(productId)
			setPinnedProductIndex(pinnedProductIndexLocal)
		}
		let positionIdsNew	= {...pinnedItemsLocal, ...selectedPromoTilesLocal, ...dynamicItemsLocal},
			pinnedProductIds = Object.entries(positionIdsNew).sort((a, b) => Number(a[1]) - Number(b[1])).map(([key]) => key);
		if (pinnedProductIds.length > 0) {
			const idIndexMapLocal = new Map();
			let elements = []
			productsLocal.forEach((obj, index) => idIndexMapLocal.set(obj.id, index));
			for( let i = 0; i < pinnedProductIds.length; i++ ){
				let currentProductId = pinnedProductIds[i]
				let productIndex = idIndexMapLocal.get(currentProductId)
				let element = productsLocal.splice(productIndex, 1)[0]
				productsLocal.forEach((obj, index) => idIndexMapLocal.set(obj.id, index))
				elements.push(element)
			}
			for( let i = 0; i < pinnedProductIds.length; i++ ){
				let element = elements[i]
				let currentProductId = pinnedProductIds[i]
				productsLocal.splice(positionIdsNew[currentProductId], 0, element)
			}
		}
		setAddedProductIds(addedProductIdsLocal)
		setAddedProducts(addedProductsLocal)
		setBuriedProducts(buriedProductsLocal)
		setBuried(buriedLocal)
		setSelectedPromoTiles(selectedPromoTilesLocal)
		setPinnedItems(pinnedItemsLocal)
		setPromoted(promotedLocal)
		setProducts(productsLocal)
		setNewProducts(newProductsLocal)
		setDynamicItems(dynamicItemsLocal)
		setActionLoader(false)
	}

	const buriedProduct = (productId) => {
		setActionLoader(true)
		let buriedLocal = [...buried],
			promotedLocal = [...promoted],
			pinnedItemsLocal = { ...pinnedItems },
			dynamicItemsLocal = {...dynamicItems},
			buriedProductsLocal = [...buriedProducts],
			newProductsLocal	= [...newProducts],
			addedProductIdsLocal	= [...addedProductIds],
			addedProductsLocal	= {...addedProducts},
			productIndex = newProductOrder.get(productId) ?? -1,
			selectedPromoTilesLocal	= {...selectedPromoTiles},
			buriedNotAttachedLocal = [...buriedNotAttached],
			pinnedWIthPromoted = {...pinnedItemsLocal, ...selectedPromoTilesLocal},
			productsLocal = [...products],
			element = productIndex >= 0 ? newProductsLocal.splice(productIndex, 1)[0] : {},
			promotedPinned	= {},
			buriedPinned	= {},
			onlyPinnedItemsLocal =  {},
			pinnedPositions = [],
			pPPPosition = typeof pinnedItemsLocal[productId] !== "undefined" ? pinnedItemsLocal[productId] : null,
			buriedPosition = productsLocal.length;
		Object.keys(pinnedWIthPromoted).forEach((item) => {
			if( promotedLocal.indexOf(item) !== -1 ){
				promotedPinned[item] = pinnedWIthPromoted[item]
			}else if( buriedLocal.indexOf(item) !== -1 ){
				buriedPinned[item] = pinnedWIthPromoted[item]
			}else{
				onlyPinnedItemsLocal[item] = pinnedWIthPromoted[item]
			}
		})
		pinnedPositions = Object.values(onlyPinnedItemsLocal).sort((a, b) => Number(a) - Number(b))
		if(productIndex === -1){
			return
		}
		while( pinnedPositions.indexOf(buriedPosition) !== -1 ){
			buriedPosition = buriedPosition - 1
		}
		if( typeof onlyPinnedItemsLocal[productId] !== "undefined" ){
			delete onlyPinnedItemsLocal[productId]
			delete pinnedItemsLocal[productId]
			pinnedPositions = Object.values(onlyPinnedItemsLocal).sort((a, b) => Number(a) - Number(b))
		}
		if (promotedLocal.indexOf(productId) !== -1) {
			let promotedIndex = promotedLocal.indexOf(productId)
			promotedLocal.splice(promotedIndex, 1)
			let sortedKeyArray = Object.entries(promotedPinned).sort((a, b) => Number(a[1]) - Number(b[1])).map(([key]) => key)
			let currentPromotedPosition = sortedKeyArray.indexOf(productId)
			for( let i = currentPromotedPosition+1; i < sortedKeyArray.length; i++ ){
				if( typeof pinnedItemsLocal[sortedKeyArray[i]] !== "undefined" ){
					let newChangePosition = pinnedItemsLocal[sortedKeyArray[i]] - 1
					while( pinnedPositions.indexOf(newChangePosition) !== -1 ){
						newChangePosition = newChangePosition - 1
					}
					pinnedItemsLocal[sortedKeyArray[i]] = newChangePosition
				}
			}
			delete promotedPinned[productId]
			// for( let i = productIndex; i < productsLocal.length; i++ ){
			// 	if( typeof productsLocal[i] !== "undefined" ){
			// 		let loopProductId = productsLocal[i].id
			// 		if( promotedLocal.indexOf(loopProductId) !== -1 ){
			// 			pinnedItemsLocal[loopProductId]	= pinnedItemsLocal[loopProductId] - 1
			// 		}else{
			// 			break;
			// 		}
			// 	}else{
			// 		break;
			// 	}
			// }
		}
		if (buriedLocal.indexOf(productId) === -1) {
			let sortedKeyArray = Object.entries(buriedPinned).sort((a, b) => Number(a[1]) - Number(b[1])).map(([key]) => key)
			for( let i = 0; i < sortedKeyArray.length; i++ ){
				if( typeof pinnedItemsLocal[sortedKeyArray[i]] !== "undefined" ){
					let newChangePosition = pinnedItemsLocal[sortedKeyArray[i]] - 1
					while( pinnedPositions.indexOf(newChangePosition) !== -1 ){
						newChangePosition = newChangePosition - 1
					}
					pinnedItemsLocal[sortedKeyArray[i]] = newChangePosition
				}
			}
			buriedLocal.push(productId)
			buriedProductsLocal.push(element)
			// for( let i = productsLocal.length-1; i >= 0; i-- ){
			// 	if( typeof productsLocal[i] !== "undefined" ){
			// 		let loopProductId = productsLocal[i].id
			// 		if( buriedLocal.indexOf(loopProductId) !== -1 ){
			// 			pinnedItemsLocal[loopProductId]	= pinnedItemsLocal[loopProductId] - 1
			// 		}else{
			// 			break;
			// 		}
			// 	}else{
			// 		break;
			// 	}
			// }
		} else if (buriedLocal.indexOf(productId) !== -1) {
			let buriedIndex = buriedLocal.indexOf(productId),
				buriedProductId = buriedLocal.splice(buriedIndex, 1)[0],
				burriedProduct = buriedProductsLocal.splice(buriedIndex, 1)[0]
			buriedLocal.splice(buriedLocal.length, 0, buriedProductId)
			buriedProductsLocal.splice(buriedProductsLocal.length, 0, burriedProduct)
			let sortedKeyArray = Object.entries(buriedPinned).sort((a, b) => Number(a[1]) - Number(b[1])).map(([key]) => key)
			let currentBuriedPosition = sortedKeyArray.indexOf(productId)
			for( let i = currentBuriedPosition+1; i < sortedKeyArray.length; i++ ){
				if( typeof pinnedItemsLocal[sortedKeyArray[i]] !== "undefined" ){
					let newChangePosition = pinnedItemsLocal[sortedKeyArray[i]] - 1
					while( pinnedPositions.indexOf(newChangePosition) !== -1 ){
						newChangePosition = newChangePosition - 1
					}
					pinnedItemsLocal[sortedKeyArray[i]] = newChangePosition
				}
			}
			delete buriedPinned[productId]
			// for( let i = productIndex; i < productsLocal.length; i++ ){
			// 	if( typeof productsLocal[i] !== "undefined" ){
			// 		let loopProductId = productsLocal[i].id
			// 		if( buriedLocal.indexOf(loopProductId) !== -1 ){
			// 			pinnedItemsLocal[loopProductId]	= pinnedItemsLocal[loopProductId] - 1
			// 		}else{
			// 			break;
			// 		}
			// 	}else{
			// 		break;
			// 	}
			// }
		}
		if ( buriedPosition <= productsLocal.length ) {
			productsLocal.splice(buriedPosition, 0, element)
		} else {
			buriedNotAttachedLocal.push(element)
		}
		pinnedItemsLocal[productId] = buriedPosition
		addedProductIdsLocal.push(productId)
		addedProductsLocal[productId]	= buriedPosition
		if (typeof pinnedProductIndex[productId] === "undefined") {
			let pinnedProductIndexLocal = { ...pinnedProductIndex }
			pinnedProductIndexLocal[productId] = originalProductOrder.get(productId)
			setPinnedProductIndex(pinnedProductIndexLocal)
		}

		let positionIdsNew	= {...pinnedItemsLocal, ...selectedPromoTilesLocal, ...dynamicItemsLocal},
			pinnedProductIds = Object.entries(positionIdsNew).sort((a, b) => Number(a[1]) - Number(b[1])).map(([key]) => key);
		if (pinnedProductIds.length > 0) {
			const idIndexMapLocal = new Map();
			let elements = []
			productsLocal.forEach((obj, index) => idIndexMapLocal.set(obj.id, index));
			for( let i = 0; i < pinnedProductIds.length; i++ ){
				let currentProductId = pinnedProductIds[i]
				let productIndex = idIndexMapLocal.get(currentProductId)
				if( typeof productIndex !== "undefined" ){
					let element = productsLocal.splice(productIndex, 1)[0]
					productsLocal.forEach((obj, index) => idIndexMapLocal.set(obj.id, index))
					elements.push(element)
				}
			}
			for( let i = 0; i < elements.length; i++ ){
				let element = elements[i]
				let currentProductId = element.id
				productsLocal.splice(positionIdsNew[currentProductId], 0, element)
			}
		}
		setPromoted(promotedLocal)
		setBuriedNotAttached(buriedNotAttachedLocal)
		setSelectedPromoTiles(selectedPromoTilesLocal)
		setPinnedItems(pinnedItemsLocal)
		setBuried(buriedLocal)
		setBuriedProducts(buriedProductsLocal)
		setProducts(productsLocal)
		setNewProducts(newProductsLocal)
		setAddedProductIds(addedProductIdsLocal)
		setAddedProducts(addedProductsLocal)
		setDynamicItems(dynamicItemsLocal)
		setActionLoader(false)
	}
	
	return (
		<React.Fragment>
			<MenuHeader title={"Products"} />
			<div className='sideBarMenuGridContainer' ref={divRef} style={{height: height, position: "relative"}}>
				<div className='menuContentWrapper'>
					<div style={{width: "100%", height: "100%", position: "relative", padding: "10px 5px"}}>
						<div className="searchInputContainer">
							<input 
								type="text"
								className="form-control"
								placeholder="Search products..."
								value={searchProductPhrase}
								disabled={disableFlag}
								onChange={(e) => { setIsLoading(true);setSearchProductPhrase(e.target.value)}}
							/>
						</div>
						{isLoading ? (
							<div className="gridProductWrapper">
								<div className='gridMenuProduct'>
									{[1,2,3,4].map((item) => (
											<ProductSkeleton key={item} />
									))}
								</div>
							</div>
						) : newProducts.length > 0 ? (
							// <div className='productsContainer'>
							// 	{newProducts.map((product, index) => {
							// 		return (
							// 			<div key={index} className='productItemContainer'>
							// 				<div style={{ maxWidth: "284px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
							// 					{product.image ? (
							// 						<img
							// 							src={product.image}
							// 							className={"img-fluid"}
							// 							title={product.title} 
							// 							alt={product.title}
							// 							style={{ maxWidth: "100%", height: "auto" }}
							// 						/>
							// 					) : (
							// 						<div className="noImagePlaceholder">
							// 							No Image
							// 						</div>
							// 					)}
							// 				</div>
							// 				<div className='productItemInfo'>
							// 					<div className='productTitleInfo'>{product.title}</div>
							// 					<div className={`selectProductButton`}>
													
							// 					</div>
							// 				</div>
							// 			</div>
							// 		)
							// 	})}
							// </div>
							<div className='gridProductWrapper'>
								<div className='gridMenuProduct'>
									{newProducts.map((product, prodIndex) => {
										return (
											<DraggableItem key={prodIndex} id={product}>
												<div product-id={"hidden_" + product.id} key={prodIndex} className='mainProductContainer' style={{ display: "flex", position: "relative", width: "100%", height: "100%" }}>
													<div id={product.id} className='selectableSideMenuProductCard' style={{ width: "100%", height: "100%" }}>
														<div className='productCard' onMouseOver={() => productMouseOver(product.id)}>
															<div className='imageAndActionContainer'>
																<div className='imageWrapper'>
																	<img src={product.image ? product.image : "https://storage.googleapis.com/roundclicksview/No%20Product%20Image%20Available.png"} alt={product.title} title={product.title} />
																</div>
																{(hoverProductId === product.id && !actionLoader) &&
																	<div className="actionBarContainer">
																		<div className="actionBarContent">
																			<div className="actionItemContainer">
																				<div className="actionIconWrapper" style={{ transform: "scale(0.8)" }} onClick={() => promptProduct(product.id)}>
																					<svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="32px" height="32px" viewBox="0 0 32 32" version="1.1">
																						<g id="surface1">
																							<path style={{ stroke: "none", fillRule: "nonzero", fill: "currentcolor", fillOpacity: 1 }} d="M 10.394531 10.601562 C 10.199219 10.40625 10.203125 10.089844 10.398438 9.894531 L 15.648438 4.644531 C 15.84375 4.453125 16.15625 4.453125 16.351562 4.644531 L 21.601562 9.894531 C 21.796875 10.089844 21.796875 10.40625 21.601562 10.601562 C 21.410156 10.796875 21.09375 10.796875 20.898438 10.601562 L 16.5 6.207031 L 16.5 19 C 16.5 19.277344 16.277344 19.5 16 19.5 C 15.722656 19.5 15.5 19.277344 15.5 19 L 15.5 6.207031 L 11.101562 10.601562 C 10.910156 10.796875 10.589844 10.796875 10.394531 10.601562 Z M 27 18.5 C 26.722656 18.5 26.5 18.722656 26.5 19 L 26.5 26 C 26.5 26.277344 26.277344 26.5 26 26.5 L 6 26.5 C 5.722656 26.5 5.5 26.277344 5.5 26 L 5.5 19 C 5.5 18.722656 5.277344 18.5 5 18.5 C 4.722656 18.5 4.5 18.722656 4.5 19 L 4.5 26 C 4.5 26.828125 5.171875 27.5 6 27.5 L 26 27.5 C 26.828125 27.5 27.5 26.828125 27.5 26 L 27.5 19 C 27.5 18.722656 27.277344 18.5 27 18.5 Z M 27 18.5 " />
																						</g>
																					</svg>
																				</div>
																			</div>
																			<div className="actionItemContainer">
																				<div className="actionIconWrapper" style={{ transform: "scale(0.8)" }} onClick={() => buriedProduct(product.id)}>
																					<svg width="35" height="35" xmlns="http://www.w3.org/2000/svg">
																						<g>
																							<path d="M33.8029 5.71891L28.7806 0.697266C28.3177 0.232422 27.7068 0 27.1025 0C26.4964 0 25.8819 0.232422 25.4257 0.697266L23.4833 2.63102C22.3624 3.75992 21.7481 5.26203 21.7481 6.81461C21.7481 8.44953 22.3956 9.5957 22.8106 10.1847L14.3524 18.6469L10.6004 14.8856C10.1887 14.4699 9.63751 14.2574 9.09961 14.2574C8.55169 14.2574 8.01254 14.4659 7.59749 14.881L3.08782 19.3309C-0.232516 22.6512 0.0829161 31.3504 1.58503 32.8578C2.24113 33.5684 4.26853 34 6.618 34C9.6561 34 13.2328 33.2875 15.1114 31.4115L19.6191 26.9032C20.4492 26.0731 20.4492 24.7284 19.6191 23.8983L15.8532 20.1477L24.3134 11.6875C24.9028 12.1025 26.0566 12.75 27.6835 12.75C29.2361 12.75 30.7382 12.1357 31.8671 11.0155L33.8016 9.07309C34.7326 8.15469 34.7326 6.64062 33.8029 5.71891ZM13.6086 29.9094C11.1761 32.3498 4.68357 32.0842 3.10973 31.3869C2.39586 29.918 2.20461 23.2854 4.59591 20.8947L9.09961 16.3891L18.1176 25.4004L13.6086 29.9094ZM32.3021 7.57031L30.363 9.50937C26.8601 13.0123 21.4579 7.65863 24.9841 4.13047L26.9265 2.19672C27.0178 2.09711 27.1755 2.09711 27.2751 2.19672L32.2975 7.21902C32.4017 7.31797 32.4017 7.47734 32.3021 7.57031Z" fill="currentcolor"></path>
																						</g>
																						<defs>
																							<clipPath id="burryClip">
																								<rect width="34" height="34" fill="white" transform="translate(0.5)"></rect>
																							</clipPath>
																						</defs>
																					</svg>
																				</div>
																			</div>
																			{/* <div className="actionItemContainer">
																			<div className="actionIconWrapper" style={{transform: "rotate(35deg)"}}>
																				<span className="material-symbols-outlined _materialIcon_1wjdg_97">push_pin</span>
																			</div>
																		</div> */}
																		</div>
																	</div>
																}
															</div>
															<div className='productInfoContainer'>
																<div className='productTitleWrapper'>
																	{product.title}
																</div>
																<div className='productSkuWrapper'>{product.sku}</div>
																<div className='productCardFooter'>
																	<div className='productPriceContainer'>
																		{formatPrice(product)}
																	</div>
																</div>
															</div>
														</div>
													</div>
												</div>
											</DraggableItem>
										)
									})}
								</div>
							</div>
						) : searchProductPhrase && (
							<div className="emptyListMessageContainer mt-5">
								<svg xmlns="http://www.w3.org/2000/svg" width="64px" height="64px" viewBox="0 0 24 24">
									<path d="M19 5H5v14h14V5zM5 3a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2V5a2 2 0 00-2-2H5z" style={{fill: "#29394e"}}/>
									<path d="M11 7h2v10h-2z" style={{fill: "#fff"}} />
									<path d="M7 11h10v2H7z" style={{fill: "#fff"}}/>
								</svg>
								<div>No Products Found</div>
							</div>
						)}
					</div>
				</div>
			</div>
		</React.Fragment>
	);
};

export default Products;